export const transitMode = {
  transitWalk: 'TRANSIT,WALK',
  bicyclePark: 'BICYCLE_PARK,WALK,TRANSIT',
  bicycle: 'BICYCLE',
  walk: 'WALK',
};

export const tripType = {
  standard: 'bicycle-park-transit',
  bicycleToBusStop: 'bicycle-to-busstop',
  bicycleHome: 'bicycle-to-home',
};

export function getTransitMode(modes) {
  const { bike, transit } = modes;
  if (bike && transit) {
    return transitMode.bicyclePark;
  } else if (bike) {
    return transitMode.bicycle;
  } else if (transit) {
    return transitMode.transitWalk;
  } else {
    return transitMode.walk;
  }
}
